import apiAction from 'common/redux/actions/apiAction';
import { POST_MY_ORG_COMPLIANCE_URL } from './apiPathConstants';
import { logError } from 'TAP/utils/commonMethods';

const getMyOrgComplianceData = (data) => {
  return {
    type: 'GET_MY_ORG_COMPLIANCE_DATA',
    payload: data,
  };
};

export const MyOrgComplianceData = (configParams) => {
  return apiAction.postAPI({
    url: POST_MY_ORG_COMPLIANCE_URL(),
    data: configParams,
    onSuccess: getMyOrgComplianceData,
    onFailure: (err) => logError('Error occured in fetching dashboard data.:', err),
    label: 'FETCH_MY_ORG_COMPLIANCE_DATA',
  });
};
